import { HomeContainer } from "../../containers";
import { useEffect } from "react";
import { getTokenFirebase } from "../../helpers";
export const HomePage = () => {
  useEffect(() => {
    getTokenFirebase();
  }, []);
  return <HomeContainer />;
};
